import { render, staticRenderFns } from "./AddressTypes.vue?vue&type=template&id=46343af2&scoped=true&"
import script from "./AddressTypes.vue?vue&type=script&lang=js&"
export * from "./AddressTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46343af2",
  null
  
)

export default component.exports